


export class ViewNcmPendenteLoteIntegracao {
  "NCM";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewNcmPendenteLoteIntegracao`.
   */
  static getModelName() {
    return "ViewNcmPendenteLoteIntegracao";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewNcmPendenteLoteIntegracao for dynamic purposes.
  **/
  static factory(data) {
    return new ViewNcmPendenteLoteIntegracao(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ViewNcmPendenteLoteIntegracao',
      plural: 'ViewNcmPendenteLoteIntegracaos',
      path: 'ViewNcmPendenteLoteIntegracaos',
      properties: {
        "NCM": {
          name: 'NCM',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ViewNcmPendenteLoteIntegracao.js